import { render, staticRenderFns } from "./tabelaSalarial.vue?vue&type=template&id=427e1b9a&"
import script from "./tabelaSalarial.vue?vue&type=script&lang=js&"
export * from "./tabelaSalarial.vue?vue&type=script&lang=js&"
import style0 from "./tabelaSalarial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports